import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getUserRole,getCustomerTypeId } from './utils/common';
import $ from 'jquery';
  
   

function Nav() 
{
  const menuclick=()=>
    {
    $('.avaal-menu >li>a').click(function(){
    if($(this).parent('li').hasClass('openSubMenu')){
        $('.avaal-menu >li').removeClass('openSubMenu')
    }
    else{
    $(this).parent('li').addClass('openSubMenu'); 
    }
    })
        }
  useEffect(() =>
    {
         menuclick();        
    },[]);

  const user_role = getUserRole(); 
  const customer_type_id=getCustomerTypeId();
 
    

  let matter;
  if(user_role === "Admin")
  {
     matter=<ul className="avaal-menu">
     <li className="active"><Link to="/AdminDashboard"> <i className="fa-sharp fa-light fa-grid-2"></i> <span> Dashboard </span> </Link></li>
    <li><Link to="/AdminDevices"><i className="fas fa-crutch"></i><span>Devices</span></Link></li> 
    <li><Link to="/AdminCustomers"><i className="fas fa-user"></i><span>Customers</span></Link></li>
    <li><Link to="/AdminVehicles"><i className="fas fa-truck"></i><span>Vehicles</span></Link></li>
    <li><Link to="/SaleDevice"><i className="fas fa-shopping-cart"></i><span>Sale Device</span></Link></li>
     <li>
    <Link to="#"><i className="fas fa-money-check"></i><span>Payment</span></Link>    
    <ul>
    <li> <Link to="/PaymentRecieve"><i className="fa-regular fa-credit-card"></i><span>Payment Receive</span></Link></li>
    <li> <Link to="/CreditNote"><i className="fa-regular fa-credit-card"></i><span>Credit Receive</span></Link></li>
    <li> <Link to="/DebitNote"><i className="fa-regular fa-credit-card"></i><span>Debit Note</span></Link></li>
    </ul></li>
    <li><Link to="/Subscription_List"><i className="fa-regular fa-credit-card"></i><span>Renewal Device</span></Link></li>  
    <li><Link to="/AdminUserList"><i className="fa-regular fa-credit-card"></i><span>User List</span></Link></li>   
    <li><Link to="/ExpiryDevices"><i className="fas fa-crutch"></i><span>Expiry Devices</span></Link></li>
    <li><Link to="#"><i className="fas fa-history"></i><span>Reports</span></Link>
    <ul>
        <li> <Link to="/LedgerReports"><i className="fa-regular fa-credit-card"></i><span>Ledger</span></Link></li>
        <li> <Link to="/OutStandingReport"><i className="fa-regular fa-credit-card"></i><span>Outstanding </span></Link></li>
        <li> <Link to="/AdmPaymentRecieveReport"><i className="fa-regular fa-credit-card"></i><span>Payment Receive </span></Link></li>
    </ul>
    </li>
    <li><Link to="/AdminCommand"><i className="fa-solid fa-screwdriver-wrench"></i><span>Device Help</span></Link></li>   
    <li>
    <Link to="/TechnicianDetails">
        <i className="fa-solid fa-user-gear"></i>
        <span>Technician Details</span>
    </Link>
    </li>
    </ul>
    
  }
  else if(user_role === "Customer" && customer_type_id ===3)    
  {

    matter=<ul className="avaal-menu"> 
    <li><Link to="/VehicleMonitor"><i className="fa-sharp fa-light fa-grid-2"></i><span>Dashboard</span></Link></li>
    <li><Link to="/Devices"><i className="fas fa-crutch"></i><span>Devices</span></Link></li>
    <li><Link to="/Vehicles"><i className="fas fa-truck"></i><span>Vehicles</span></Link></li>
    <li><Link to="/Drivers"><i className="fas fa-user"></i><span>Drivers</span></Link></li>    
    <li><Link to="/Alert"><i className="fas fa-bell"></i><span>Alerts</span></Link></li> 
     {/*<li><Link to="/AlertSettings"><i class="fa-solid fa-screwdriver-wrench"></i><span>Alert Settings</span></Link></li>    */}
    <li><Link to="/SUserList"><i className="fas fa-user"></i><span>User List</span></Link></li>  
    <li><Link to="/Reports"><i className="fas fa-history"></i><span>Reports</span></Link></li>  
     </ul>       

  }
  else if(user_role === "Customer" && customer_type_id ===4)    
  {
    
    matter=<ul className="avaal-menu"> 
    <li><Link to="/VehicleMonitor"><i className="fa-sharp fa-light fa-grid-2"></i><span>Dashboard</span></Link></li>
    <li><Link to="/Devices"><i className="fas fa-crutch"></i><span>Devices</span></Link></li>
    <li><Link to="/Alert"><i className="fas fa-bell"></i><span>Alerts</span></Link></li> 
    <li><Link to="/AlertSettings"><i class="fa-solid fa-screwdriver-wrench"></i><span>Alert Settings</span></Link></li>    
     
     </ul>       

  }  
  else     
  {

    matter=<ul className="avaal-menu"> 
    <li><Link to="/VehicleMonitor"><i className="fa-sharp fa-light fa-grid-2"></i><span>Dashboard</span></Link></li>
    <li><Link to="/Devices"><i className="fas fa-crutch"></i><span>Devices</span></Link></li>
    <li><Link to="/Vehicles"><i className="fas fa-truck"></i><span>Vehicles</span></Link></li>
    <li><Link to="/Drivers"><i className="fas fa-user"></i><span>Drivers</span></Link></li> 
    <li><Link to="#"><i className="fas fa-history"></i><span>Fuel Analysis</span></Link>    
    <ul>
    <li> <Link to="/CFuelDetails"><i class="fas fa-tint"></i><span>Fuel Details</span></Link></li>
    <li> <Link to="/CFuelRefill"><i class="fas fa-tint"></i><span>Fuel Refill</span></Link></li>
    <li> <Link to="/CFuelTheft"><i class="fas fa-tint"></i><span>Fuel Theft</span></Link></li>
    <li> <Link to="/CFuelConsumed"><i class="fas fa-tint"></i><span>Fuel Consumed</span></Link></li>
    </ul>
    </li>  
    <li><Link to="/Alert"><i className="fas fa-bell"></i><span>Alerts</span></Link></li> 
    <li><Link to="/AlertSettings"><i class="fa-solid fa-screwdriver-wrench"></i><span>Alert Settings</span></Link></li>  
    <li><Link to="/GeoFenceAlert"><i class="fa-solid fa-screwdriver-wrench"></i><span>Geofence Settings</span></Link></li>    
    <li><Link to="/Reports"><i className="fas fa-history"></i><span>Reports</span></Link></li>  
    {/*  <li><Link to="/History"><i className="fas fa-history"></i><span>History</span></Link></li> 
    <li><Link to="/UserPoligone"><i className="fas fa-history"></i><span>Poligone</span></Link></li>   */}
     </ul> 
        

  }


  return (    <>
                {matter}
                </>
  );
}


export default Nav;